import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../../ThemeContext';
import Button from '../Button/Button';
import CancelIcon from '../../../../theme/assets/icons/cancel_confirm.svg';

import styles from './PaymentPopup.module.scss';

type Props = {
  type: 'error' | 'cancelled' | 'success';
  title: string | null;
  message: string | null;
  onCloseButtonClick: () => void;
};

const PaymentPopup: React.FC<Props> = ({ type, title, message, onCloseButtonClick }: Props) => {
  const { t } = useTranslation('account');
  const { universalStyles } = useTheme();
  const baseStyle = { color: universalStyles.carouselPaginationInactive.backgroundColor };
  
  return (
    <div className={styles.container}>
      { type === 'success' ?
        <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="29.0014" cy="28.9881" rx="25.7045" ry="25.6927" fill="#E32652" />
        <ellipse cx="29" cy="28.9866" rx="29" ry="28.9866" fill="#22C55E" />
        <path d="M17 30.186L24.1588 37.2843C24.5486 37.6708 25.1772 37.6708 25.567 37.2843L42 20.9902" stroke="white" strokeWidth="4" strokeLinecap="round" />
      </svg> : 
       <span className={styles.icon}>
        <img src={CancelIcon} />
      </span>
      }
      <h2 className={styles.title} style={universalStyles.primaryTextColor}>{title}</h2>
      <p className={styles.message} style={baseStyle}>{message}</p>
      <div style={{ width: '100%' }}>
        <Button label={t('checkout.okay')} onClick={onCloseButtonClick} color="primary" variant="contained" size="large" fullWidth />
      </div>
    </div>
  );
};

export default PaymentPopup;
